// api request url
export const baseUrl = "https://apin-oabu.onrender.com/api/v1";
// export const baseUrl = "http://localhost:5000/api/v1";
